import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MessageSearch } from 'app/core/o2c/inquiries/models/message-search-model';
import { NotificationDetailComponent } from 'app/views/partials/layout/topbar/notification-detail/notification-detail.component';

export interface MessageHistoryDialogData {
    title: string;
    messages: MessageSearch[];
}

@Component({
  standalone: false,
    selector: 'kt-message-history-dialog',
    templateUrl: './message-history-dialog.component.html',
    styleUrls: ['./message-history-dialog.component.scss']
})
export class MessageHistoryDialogComponent implements OnInit {

    displayedColumns = [
        'documentType',
        'documentId',
        'systemDate',
        'customerNumber',
        'referenceID',
        'statusFlag',
    ];

    dataSource: MatTableDataSource<MessageSearch>;
    filter: string = '';

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    constructor(
        public dialogRef: MatDialogRef<MessageHistoryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MessageHistoryDialogData,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.dataSource = new MatTableDataSource<MessageSearch>(this.data.messages);
        setTimeout(() => {
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }

    /**
     * Apply filter to the table
     */
    applyFilter(filterValue: string): void {
        if (this.dataSource) {
            this.dataSource.filter = filterValue.trim().toLowerCase();
        }
    }

    /**
     * Clear the filter
     */
    clearFilters(): void {
        this.filter = '';
        if (this.dataSource) {
            this.dataSource.filter = '';
        }
    }

    /**
     * Close the dialog
     */
    onClose(): void {
        this.dialogRef.close();
    }

    /**
     * Open message details dialog
     * @param element The message element to show details for
     */
    openMessageDetails(element: MessageSearch): void {
        const notificationModal = this.dialog.open(NotificationDetailComponent, {
            width: '650px',
            height: '670px'
        });
        notificationModal.componentInstance.notification = element as any;
    }
}

